export class PlanSubscriptionsVM {
    status: string;
    status_update_time: string;
    SubcriptionId: string;
    PlanId: string;
    start_time: string
    FullName: string;
    email_address: string;
    payer_id: string;
    address_line_1: string;
    admin_area_2: string;
    postal_code: string;
    country_code: string;
    next_billing_time?: string;
    final_payment_time: string;
    failed_payments_count?: number;
    UserId: string;
    CreatedDate: string;
    UpdatedDate: string;
    CreatedBy: string;
    cycles_completed?: number;
    cycles_remaining?: number;
    userDetailsId?:number;
    selectedPlan?:number;
}